import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerRequestSubsidyInfoRepository } from 'application/repositorySchemas/IBuyerRequestSubsidyInfoRepository';
import { type IBuyerRequestSubsidyInfoClient } from 'interfaceAdapter/gatewaySchemas/IBuyerRequestSubsidyInfoClient';

@injectable()
export class BuyerRequestSubsidyInfoRepository implements IBuyerRequestSubsidyInfoRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerRequestSubsidyInfoClient')
        public readonly buyerRequestSubsidyInfoClient: IBuyerRequestSubsidyInfoClient,
    ) {}

    public async request() {
        const { data, message } = await this.buyerRequestSubsidyInfoClient.post({
            token: this.buyerUserToken.get() || '',
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
